import r from "react";
import c from "@loadable/component";
const l = (e) => {
  const t = e.replace(/([a-z0-9])([A-Z])/g, "$1 $2").split(" ")[0].toLocaleLowerCase();
  return c(
    () => import(`react-icons/${t}/index.js`),
    {
      resolveComponent: (n) => n[e]
    }
  );
}, s = ({
  iconName: e,
  iconProps: t
}) => {
  const o = l(e);
  return /* @__PURE__ */ r.createElement(o, { ...t, "aria-hidden": "true" });
};
export {
  s as IconReact
};
